import { fork } from 'typed-redux-saga';
import watchLoginActionTrackingSaga from './watchLoginActionTrackingSaga';
import watchLogoutActionTrackingSaga from './watchLogoutActionTrackingSaga';

function* sessionDataTrackingSaga(): Generator {
  yield* fork(watchLoginActionTrackingSaga);
  yield* fork(watchLogoutActionTrackingSaga);
}

export default sessionDataTrackingSaga;
